import styled from 'styled-components/macro';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { getTextStyles } from '@yme/utils/styles';
export const FinanceTextStyled = styled.span `
  ${getTextStyles('Ubuntu', 500, 14, 20)}

  color: ${colorCoreBlack300};
`;
export const SVGIconInfo = styled(SVGIcon) `
  path {
    fill: ${colorCoreBlack900Base};
  }
`;
